<button 
  mat-icon-button 
  [color]="color"
  class="edit-button" 
  (click)="onClick()"
  [disabled]="disabled"
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition">
  <mat-icon>edit</mat-icon>
</button>
